import { VENDOR_THEME_PREFIX_NAME } from "./constants";

export const pages = {
  HOME: "/",
  FILES: "/files",
  PACKAGE: "/package",
  ACCOUNT: "/account",
  HELP: "/help",
  MAKING: "/making",
  VIDEOS: "/videos",
  CONTRACTS: "/contracts",
  LINK: "/link",
  LOGIN: "/login",
  SETTINGS: `/account/settings`,
};

const themingVendorPrefix = `:${VENDOR_THEME_PREFIX_NAME}?`;

export const pagesForRouter = Object.keys(pages).reduce<typeof pages>(
  (accumulator, key) => {
    accumulator[key] = `${themingVendorPrefix}${pages[key]}`;
    return accumulator;
  },
  {} as typeof pages
);

export const getRoute = (basePageUrl: string, vendorPrefix = "") => {
  if (vendorPrefix) {
    return `/${vendorPrefix}${basePageUrl}`;
  } else {
    return `${basePageUrl}`;
  }
};
